import { Extension } from '@tiptap/core';
import { createScrollHandlerPlugin } from './scroll-handler-plugin';

export const SCROLL_HANDLER_EXTENSION_NAME = 'scrollHandler';

export const ScrollHandler = Extension.create({
    name: SCROLL_HANDLER_EXTENSION_NAME,

    addProseMirrorPlugins() {
        return [createScrollHandlerPlugin()];
    },
});
